module.exports = __webpack_public_path__ + "img/ExitusC_personas2.649cf9a1.png";